export default __webpack_public_path__ + "static/media/pina.4f110fae.png";